import { useEffect, useRef } from "react";

// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

type IntroTransitionProps = {
    initialCSS: string;
    transitionCSS: string;
    finalCSS: string;
    children?: React.ReactNode;
};

export const IntroTransition = ({
    initialCSS,
    transitionCSS,
    finalCSS,
    children
}: IntroTransitionProps) => {
    const myRef = useRef<HTMLDivElement>(null);

    const theCSS = css`
        ${initialCSS}
        ${transitionCSS}
    &.final {
            ${finalCSS}
        }
    `;

    useEffect(() => {
        setTimeout(() => {
            if (myRef.current) {
                myRef.current.classList.add("final");
            }
        });
    });

    return (
        <div ref={myRef} css={theCSS}>
            {children}
        </div>
    );
};
